import { lazyWithPreload } from 'react-lazy-with-preload';

const AccountLayout = lazyWithPreload(() => import('./layouts/AccountLayout/AccountLayout'));

const ProfilePage = lazyWithPreload(() => import('./pages/profile/Page'));
const ClientPage = lazyWithPreload(() => import('./pages/organisation/Page'));

const Routes = [
    {
        path: 'account',
        element: <AccountLayout />,
        children: [
            {
                path: '',
                element: <ProfilePage />,
            },
            {
                path: 'organisation',
                element: <ClientPage />,
            },
        ],
    },
];

export default Routes;
